/* unplugin-vue-components disabled *//* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SmyPopup',
  props: {
    value: Boolean,
    popupStyle: {
      type: Object
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  deactivated: function deactivated() {},
  methods: {},
  data: function data() {
    return {
      show: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      this.$emit('input', val);
    }
  },
  beforeDestroy: function beforeDestroy() {}
};